var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showH5 == true)?_c('div',{attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTip == true),expression:"showTip == true"}],staticClass:"download-layer"},[_c('img',{staticClass:"download-layer-img",attrs:{"src":require("./assets/Montmorillonite.png"),"alt":"","srcset":""}})]),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }